import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getConceptSettings, cloudinaryBaseUrls } from './utils.js';
import { ConceptBadge as ConceptBadge$2 } from './ConceptBadge.style.js';
import { jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';
import CloudinaryPicture from '../Picture/CloudinaryPicture.js';

var _excluded = ["className", "concept", "onClick", "alt", "lazy"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ConceptBadge = function ConceptBadge(_ref) {
  var _conceptSettings$altT;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    concept = _ref.concept,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useGlobals = useGlobals(),
    siteId = _useGlobals.siteId;
  var conceptSettings = getConceptSettings(concept);
  if (!concept || !conceptSettings) {
    return false;
  }
  var desktopHeight = conceptSettings.desktopSize;
  var mobileHeight = conceptSettings.mobileSize;
  return /*#__PURE__*/jsx(ConceptBadge$2, _objectSpread(_objectSpread({
    className: className,
    onClick: onClick
    // @ts-ignore
    ,
    $concept: concept,
    $desktopSize: conceptSettings.desktopSize,
    $mobileSize: conceptSettings.mobileSize
  }, rest), {}, {
    children: /*#__PURE__*/jsx(CloudinaryPicture, {
      img: {
        cloudinaryUriTemplate: "".concat(cloudinaryBaseUrls[siteId], "/{+transform}").concat(conceptSettings.url)
      },
      sizes: [{
        breakpoint: 768,
        height: desktopHeight
      }, {
        height: mobileHeight
      }],
      formats: conceptSettings.svgSources ? ['svg'] : undefined,
      lazy: lazy,
      retina: true,
      alt: (_conceptSettings$altT = conceptSettings.altText) !== null && _conceptSettings$altT !== void 0 ? _conceptSettings$altT : alt
    })
  }));
};
var ConceptBadge$1 = ConceptBadge;

export { ConceptBadge$1 as default };
//# sourceMappingURL=ConceptBadge.js.map
